import Input from "./input"

export default {
  variants: {
    filled: Input.variants.filled.field,
  },
}
